const hasDoubleExtension = (filename, allowedTypes) => {
  const exts = allowedTypes.map(type => {
    const match = type.match(/image\/(.*)/);
    return match ? match[1] : null;
  }).filter(Boolean);

  const parts = filename.split('.');
  if (parts.length <= 2) return false; // "nom.ext"

  // Cas "nom.archive.tar.gz" (parts.length > 2)
  // Si la dernière extension est autorisée, mais il existe une extension juste avant, on bloque
  const lastExt = parts[parts.length - 1].toLowerCase();

  if (exts.includes(lastExt) && parts.length > 2) {
    return true;
  }
  return true;
};

const readURL = (input) => {
  const file = input.files[0];
  const maxSize = 10485760; // 10 MB en octets
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/bmp'];

  if (hasDoubleExtension(file.name, allowedTypes)) {
    alert("Le fichier sélectionné présente une double extension ou un nom non valide. Veuillez choisir un autre fichier.");
    input.value = "";
    return;
  }

  if (!allowedTypes.includes(file.type)) {
    alert("Veuillez sélectionner une image de type jpeg, jpg, png, webp, ou bmp.");
    input.value = "";
    return;
  }
  
  if (file.size > maxSize) {
    alert("La taille du fichier dépasse la limite de 10 MB. Veuillez choisir un autre fichier.");
    input.value = "";
  } else {
    const imagePreview = document.querySelector('#img_prev');
    imagePreview.style.display = "";
    if (document.querySelector('#avatar-remove')) {
      const avatarImage = document.querySelector('#avatar-remove');
      avatarImage.style.display ="none";
    }
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        $('#img_prev')
          .attr('src', e.target.result)
          .width(45)
          .height(45);
      };
      reader.readAsDataURL(input.files[0]);
    }
  }
}

export { readURL };
